import * as R from 'ramda';
import parseReview from './parseReview';

export default function parseReviews(items) {
  return R.map(parseReview, items);
}
